module.exports = __webpack_public_path__ + "static/media/google-play-badge.710d6202.png";